import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HvlNgSharedModule, PrimengSharedModule} from "@hvlng/framework-core/shared";
import {UiSharedModule} from "ui-shared";
import {TranslateModule} from "@ngx-translate/core";
import {TitleSearchComponent} from "./component/title-search.component";



@NgModule({
  declarations: [TitleSearchComponent],
    imports: [CommonModule, PrimengSharedModule, HvlNgSharedModule, UiSharedModule, TranslateModule],
    exports:[TitleSearchComponent]
})
export class TitleSearchModule { }
